//React Components and Hooks
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
//Material UI components
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
//Material UI Functions
import { makeStyles } from "@mui/styles";
import React from "react";
//Contexts

//Styling
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    "& label.Mui-focused": {
      color: theme.palette.secondary.main,
    },
    "& .MuiTextField-underline:after": {
      borderBottomColor: theme.palette.secondary.main,
    },
    "& .MuiTextFieldInput-root": {
      "&:hover fieldset": {
        borderColor: theme.palette.secondary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.secondary.main,
      },
    },
  },
  dropDown: {
    minWidth: 150,
  },
  filter: {},
  filterButton: {},
}));

const TableTools = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 3, flexWrap: 'wrap', p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 16.67%' } }}>
          <FormControl
            variant="outlined"
            size="small"
            className={classes.dropDown}
          >
            <InputLabel>Property Name</InputLabel>
            <Select autoWidth={true} label="Property Name">
              <option value={10}>All</option>
              ]
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 16.67%' } }}>
          <Button variant="contained" color="secondary">
            Get Reports
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default TableTools;
